import React, { forwardRef } from "react";

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// Custom styles for SuiButton
import SuiButtonRoot from "./SuiButtonRoot";
import { CircularProgress } from "@mui/material";

const SuiButton = forwardRef(
    (
        {
            color,
            variant,
            size,
            circular,
            iconOnly,
            children,
            fontSize,
            fontWeight,
            isLoading,
            disabled,
            width,
            margin,
            display,
            ...rest
        },
        ref
    ) => (
        <SuiButtonRoot
            {...rest}
            ref={ref}
            //color="primary"
            variant={variant === "gradient" ? "contained" : variant}
            size={size}
            disabled={isLoading ? true : disabled}
            ownerState={{ color, variant, size, circular, iconOnly, fontSize, fontWeight, width }}>
            {isLoading && <CircularProgress color="white" size={22} />}
            {!isLoading && children}
        </SuiButtonRoot>
    )
);

// Setting default values for the props of SuiButton
SuiButton.defaultProps = {
    size: "medium",
    variant: "contained",
    color: "white",
    circular: false,
    iconOnly: false
};

// Typechecking props for the SuiButton
SuiButton.propTypes = {
    size: PropTypes.oneOf(["small", "medium", "large"]),
    variant: PropTypes.oneOf(["text", "contained", "outlined", "gradient"]),
    color: PropTypes.oneOf([
        "white",
        "primary",
        "secondary",
        "info",
        "success",
        "warning",
        "error",
        "light",
        "dark",
        "#52BBBA",
        "gray",
        "greenSector"
    ]),
    circular: PropTypes.bool,
    iconOnly: PropTypes.bool,
    children: PropTypes.node.isRequired
};

export default SuiButton;
